import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentSetListResultVo} from '../../common/shared/api/nicolas/vo/ContentSetListResultVo.interface';

/**
 * 콘텐츠 세트 목록 조회
 *
 * Origin: pageNicolasApi.getContentSetList
 * API: GET /api/v1/content/set/list
 */
export async function getContentSetList(
  {
    seriesId,
    productId,
  }: {
    seriesId: number;
    productId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentSetListResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/set/list',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        product_id: productId,
      },
    },
    options
  );
  return response.data;
}
